const e = {
  graphite950: "#181A1F",
  graphite900: "#1E2128",
  graphite850: "#282D36",
  graphite800: "#333945",
  graphite700: "#434C5B",
  graphite600: "#687286",
  graphite500: "#7D879B",
  graphite400: "#929BAE",
  graphite300: "#A9B1C1",
  graphite200: "#C1C7D4",
  graphite100: "#D9DDE5",
  graphite50: "#EEEFF3",
  graphite10: "#FAFAFF"
}, a = {
  black950: "#161616",
  black900: "#25252B",
  black850: "#303037",
  black800: "#40404A",
  black700: "#5E5E64",
  black600: "#717178",
  black500: "#86868D",
  black400: "#9B9AA2",
  black300: "#B0B0B7",
  black200: "#C6C6CD",
  black100: "#DCDCE3",
  black50: "#F3F3F9",
  black10: "#FAFAFF"
}, r = {
  blue900: "#060076",
  blue800: "#070C9A",
  blue700: "#0F2CBB",
  blue600: "#1F48DA",
  blue500: "#3363F7",
  blue400: "#5D79E9",
  blue300: "#629AFF",
  blue200: "#A8B7F0",
  blue100: "#CCD4F4",
  blue50: "#B9EEFF"
}, g = {
  purple900: "#360075",
  purple800: "#4C0099",
  purple700: "#6200BA",
  purple600: "#7900D9",
  purple500: "#902EF6",
  purple400: "#A751FF",
  purple300: "#BF71FF",
  purple200: "#D690FF",
  purple100: "#EEB0FF",
  purple50: "#FFCFFF"
}, F = {
  red900: "#5D0000",
  red800: "#7E0000",
  red700: "#9F0000",
  red600: "#BE0000",
  red500: "#DC0011",
  red400: "#F83833",
  red300: "#FF5C51",
  red200: "#FF7E6F",
  red100: "#FF9F8E",
  red50: "#FFC0AF"
}, l = {
  orange900: "#6B340F",
  orange800: "#96440E",
  orange700: "#C0540C",
  orange600: "#E9640B",
  orange500: "#F57A29",
  orange400: "#F69351",
  orange300: "#F6AB7A",
  orange200: "#F6C4A2",
  orange100: "#F8DCC9",
  orange50: "#FCF3EE"
}, p = {
  green900: "#004800",
  green800: "#005C08",
  green700: "#007218",
  green600: "#00872A",
  green500: "#009D3E",
  green400: "#00B353",
  green300: "#39C96A",
  green200: "#5EDF82",
  green100: "#80F59C",
  green50: "#A2FFB8"
}, t = {
  whiteAlfa900: "rgba(255, 255, 255, 1)",
  whiteAlfa800: "rgba(255, 255, 255, 0.9)",
  whiteAlfa700: "rgba(255, 255, 255, 0.8)",
  whiteAlfa600: "rgba(255, 255, 255, 0.7)",
  whiteAlfa500: "rgba(255, 255, 255, 0.6)",
  whiteAlfa400: "rgba(255, 255, 255, 0.32)",
  whiteAlfa300: "rgba(255, 255, 255, 0.24)",
  whiteAlfa200: "rgba(255, 255, 255, 0.16)",
  whiteAlfa100: "rgba(255, 255, 255, 0.12)",
  whiteAlfa50: "rgba(255, 255, 255, 0.08)"
}, A = {
  graphiteAlfa900: "rgba(31, 32, 37, 1)",
  graphiteAlfa800: "rgba(31, 32, 37, 0.9)",
  graphiteAlfa700: "rgba(31, 32, 37, 0.8)",
  graphiteAlfa600: "rgba(31, 32, 37, 0.7)",
  graphiteAlfa500: "rgba(31, 32, 37, 0.6)",
  graphiteAlfa400: "rgba(31, 32, 37, 0.32)",
  graphiteAlfa300: "rgba(31, 32, 37, 0.24)",
  graphiteAlfa200: "rgba(31, 32, 37, 0.16)",
  graphiteAlfa100: "rgba(31, 32, 37, 0.12)",
  graphiteAlfa50: "rgba(31, 32, 37, 0.08)"
};
export {
  a as black,
  r as blue,
  e as graphite,
  A as graphiteAlfa,
  p as green,
  l as orange,
  g as purple,
  F as red,
  t as whiteAlfa
};
